// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Image-module-container-3t_ZY{width:100%;height:100px;background-repeat:no-repeat;background-size:contain;background-position:center}", ""]);
// Exports
exports.locals = {
	"container": "Image-module-container-3t_ZY"
};
module.exports = exports;
